'use client'

import { Box, Flex, VStack } from '@chakra-ui/react'
import { ContentContainer } from 'ui'
import { keyframes } from '@emotion/react'
import { FC } from 'react'
import { SectionLabel } from '../ui/SectionLabel'
import { SectionTitle } from '../ui/SectionTitle'
import { QuoteCard } from '../ui/QuoteCard'

const scrollQuotes = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
`

type Quote = {
  text: string
  author: string
}

export type QuotesCarouselProps = {
  quotes: Quote[]
}

export const QuotesCarousel: FC<QuotesCarouselProps> = ({ quotes }) => {
  // Duplicate quotes for seamless loop
  const allQuotes = [...quotes, ...quotes]

  return (
    <Box as="section" w="100%" py={{ base: 16, md: 32 }} bg="background.dark" color="white">
      <ContentContainer mb={10}>
        <VStack align="start" spacing={0} w="100%">
          <SectionLabel color="teal.300">What Clients Say</SectionLabel>
          <SectionTitle color="white">In their words</SectionTitle>
        </VStack>
      </ContentContainer>

      <Box
        overflow="hidden"
        sx={{
          maskImage: 'linear-gradient(to right, transparent, black 5%, black 95%, transparent)',
          WebkitMaskImage:
            'linear-gradient(to right, transparent, black 5%, black 95%, transparent)'
        }}
      >
        <Flex
          gap={10}
          animation={`${scrollQuotes} 40s linear infinite`}
          w="max-content"
          _hover={{ animationPlayState: 'paused' }}
        >
          {allQuotes.map((quote, index) => (
            // the second copy only exists for the loop; screen readers and agents read it once
            <Box key={index} display="contents" aria-hidden={index >= quotes.length || undefined}>
              <QuoteCard text={quote.text} author={quote.author} />
            </Box>
          ))}
        </Flex>
      </Box>
    </Box>
  )
}
